import React from 'react';

interface StoreLinksProps {
    showStoreLinks: boolean;
}

const StoreLinks: React.FC<StoreLinksProps> = ({ showStoreLinks }) => {
    if (!showStoreLinks) return null;

    return (
        <div className="store-links">
            <a href="https://apps.apple.com/ru/app/lucidme/id907469483" className="logo-wrapper">
                <img
                    src="https://static-remspace.s3.amazonaws.com/assets/img/apple-store-logo.svg"
                    alt="App Store"
                    className="store-logo"
                />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.phaser&hl=en" className="logo-wrapper">
                <img
                    src="https://static-remspace.s3.amazonaws.com/assets/img/google-play-logo.svg"
                    alt="Google Play"
                    className="store-logo"
                />
            </a>
        </div>
    );
};

export default StoreLinks; 